import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/root.js';
import { overviewRoute } from './routes/overview.js';
import { agentRoute } from './routes/agent.js';
import { exceptionsRoute } from './routes/exceptions.js';
import { inboxRoute } from './routes/inbox.js';
import { approvalsRoute } from './routes/approvals.js';
import { briefsRoute } from './routes/briefs.js';
import { campaignsRoute } from './routes/campaigns.js';
import { automationsRoute } from './routes/automations.js';
import { contactsRoute } from './routes/contacts.js';
import { ordersRoute } from './routes/orders.js';
import { auditRoute } from './routes/audit.js';
import { signInRoute } from './routes/sign-in.js';
import { settingsRoute } from './routes/settings.js';

/**
 * Code-based route tree. Routes are registered here explicitly rather than
 * discovered from the filesystem, so an unfinished page cannot become reachable
 * by accident.
 */
const routeTree = rootRoute.addChildren([
  overviewRoute,
  signInRoute,
  agentRoute,
  inboxRoute,
  exceptionsRoute,
  briefsRoute,
  campaignsRoute,
  approvalsRoute,
  contactsRoute,
  ordersRoute,
  auditRoute,
  automationsRoute,
  settingsRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
